const o = {
  position: "absolute",
  top: -1,
  flexShrink: 0
};
export {
  o as actionsContainer
};
